import React from 'react';
import { graphql, useFragment, useLazyLoadQuery } from 'react-relay';
import { MobileTopUpRewardsQuery } from './__generated__/MobileTopUpRewardsQuery.graphql';
import RedemptionOptionItem from 'components/organisms/RedemptionOptions/RedemptionOptionItem';
import classes from './MobileTopUpRewards.module.scss';
import { REWARDS } from 'components/pages/pages';
import A from 'components/atoms/A/A';
import ChevronIcon from 'components/assets/ChevronIcon';
import Txt from 'components/atoms/Txt/Txt';
import Heading from 'components/atoms/Heading/Heading';

export interface Props {}

const query = graphql`
  query MobileTopUpRewardsQuery($redemptionType: RedemptionTypeKey!) {
    redemptionOptions(input: { redemptionType: $redemptionType }) {
      edges {
        node {
          id
          name
          amountDenominations {
            panelistCost {
              subUnitAmount
            }
          }
          ...useRedemptionOptionItemQuery_optionRef
        }
      }
    }
  }
`;

export default function MobileTopUpRewards() {
  const redemptionOptions = useLazyLoadQuery<MobileTopUpRewardsQuery>(
    query,
    { redemptionType: 'MOBILE' },
    {
      fetchPolicy: 'store-and-network',
    },
  );

  return (
    <div className={classes.root}>
      <div className={classes.infoContent}>
        <A className={classes.backLink} href={REWARDS.path} aria-label="Back to Rewards">
          <ChevronIcon className={classes.backLinkChevron} />
        </A>
        <Heading level="2" className={classes.title}>
          Mobile Top Up Cards
        </Heading>
        <Txt className={classes.description}>
          Choose your mobile top up reward from the options below
        </Txt>
      </div>

      <ul className={classes.rewardList}>
        {/* We can re-add filters when necessary (see RedemptionOptions in LP repo) */}
        {redemptionOptions?.redemptionOptions?.edges.map(({ node }) => (
          <RedemptionOptionItem redemptionType={'MOBILE'} key={node.id} optionRef={node} />
        ))}
      </ul>
    </div>
  );
}
